import { GetVideoCreditsResponse, VideoCredits } from '../fymAPI.types';

/**
 * Adds the sums the screens show to the credits answer. The plan count goes first, then the
 * packs. A plan with no limit (null) has no "left" number.
 */
export function toVideoCredits(response: GetVideoCreditsResponse): VideoCredits {
  const planLeft = response.limit === null ? null : Math.max(0, response.limit - response.used);
  const packBalance = Math.max(0, response.packBalance);
  return {
    ...response,
    packBalance,
    planLeft,
    totalLeft: planLeft === null ? null : planLeft + packBalance,
  };
}
